import React, { useContext, useEffect } from 'react';
import SubmissionRow from './SubmissionRow';
import ColumnFilterField from './ColumnFilterField';
import SorterIcon from './SorterIcon';
import { FilterFieldsContext } from '../../../hooks/Contexts';
import { SubmissionsLoading } from '../../common/LoadSpinner';
import { QueryContext } from '../../../hooks/Contexts';

const SubmissionTable = ({ submissions, isLoading, hasLocalQuota }) => {
  const {
    queryParams,
    setQueryParams,
    expandable,
    expanded,
    handleExpand,
    filteringByExpanded,
  } = useContext(QueryContext);
  const { filtFields } = useContext(FilterFieldsContext);

  useEffect(() => {
    const preventNavOnTextSelect = (e) => {
      const isTextSelected = document.getSelection();
      const table = document.getElementById('submissions-index-table');
      if (table?.contains(e.target) && isTextSelected.type === 'Range')
        e.stopPropagation();
    };
    document.addEventListener('click', preventNavOnTextSelect, true);
    return () => {
      document.removeEventListener('click', preventNavOnTextSelect, true);
    };
  }, []);

  const handleSort = (e, id, direction) => {
    // "id" can refer to submission "id", "created_at", or field.id
    direction = direction === 'up' ? 'asc' : 'desc';
    setQueryParams((params) => {
      return { ...params, sort: id + '.' + direction };
    });
  };

  const handleFilter = (id, value) => {
    if (queryParams['filters'][id] && queryParams['filters'][id] == value) {
      return;
    }
    setQueryParams((params) => {
      params.filters = { ...params.filters } || {};
      if (value) {
        params['filters'][id] = value;
      } else {
        delete params['filters'][id];
      }
      return { ...params, page: '1', filters: { ...params.filters } };
    });
  };

  const removeFilter = (id) => {
    setQueryParams((params) => {
      delete params['filters'][id];
      return { ...params };
    });
  };

  return (
    <table id='submissions-index-table'>
      <thead>
        <tr>
          <th id='sub-id'>
            <span className='unfiltered-field-title'>ID</span>
            <SorterIcon id='id' handleSort={handleSort} />
          </th>
          {expanded
            ? filtFields.map((field, i) => {
                return (
                  <ColumnFilterField
                    key={`filt-col-${field.id}`}
                    field={field}
                    handleFilter={handleFilter}
                    handleSort={handleSort}
                    removeFilter={removeFilter}
                  />
                );
              })
            : filtFields.slice(0, 4).map((field, i) => {
                return (
                  <ColumnFilterField
                    key={`filt-col-${field.id}`}
                    field={field}
                    handleFilter={handleFilter}
                    handleSort={handleSort}
                    removeFilter={removeFilter}
                  />
                );
              })}
          {expandable && !expanded && (
            <th
              className={filteringByExpanded ? 'tiny active' : 'tiny'}
              onClick={handleExpand}
              title='Expand'
            >
              <i className='fa-solid fa-left-right' />
            </th>
          )}
          <th className='small'>
            <div className='non-filterable'>Submitted</div>
          </th>
          <th>
            <SorterIcon id='created_at' handleSort={handleSort} />
          </th>
        </tr>
      </thead>
      <tbody>
        {isLoading ? (
          <SubmissionsLoading />
        ) : submissions.length > 0 ? (
          submissions.map((sub) => {
            return (
              <SubmissionRow
                submission={sub}
                key={sub.id}
                hasLocalQuota={hasLocalQuota}
              />
            );
          })
        ) : (
          <tr className='empty'>
            <td colSpan='100%'>There are no submissions for this form.</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default SubmissionTable;
